module.exports = __webpack_public_path__ + "static/media/demoday.03534b95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/OpenChallenges/demoday.svg
// module id = 182
// module chunks = 0